/**
 * ISO-3166 alpha-3 → alpha-2 country codes for the 27 EU member states. The sales-journal endpoint
 * returns the alpha-3 form (nullable); the Estonian VD filing wants the alpha-2 code. Only EU members
 * are listed because the VD report only ever covers FOREIGN_EU rows; an unmapped or null country falls
 * back to the VAT number's leading 2-letter prefix at the call site.
 */
export const EU_ISO3_TO_ISO2: Record<string, string> = {
    AUT: 'AT',
    BEL: 'BE',
    BGR: 'BG',
    HRV: 'HR',
    CYP: 'CY',
    CZE: 'CZ',
    DNK: 'DK',
    EST: 'EE',
    FIN: 'FI',
    FRA: 'FR',
    DEU: 'DE',
    // Exception: EU VAT declarations use "EL" for Greece, not its ISO-3166 alpha-2 code "GR".
    GRC: 'EL',
    HUN: 'HU',
    IRL: 'IE',
    ITA: 'IT',
    LVA: 'LV',
    LTU: 'LT',
    LUX: 'LU',
    MLT: 'MT',
    NLD: 'NL',
    POL: 'PL',
    PRT: 'PT',
    ROU: 'RO',
    SVK: 'SK',
    SVN: 'SI',
    ESP: 'ES',
    SWE: 'SE',
};
